import React from "react";
import { CABINET_LANGUAGES } from "./i18n";
import { CABINET_CURRENCIES } from "./money";

/**
 * Language and currency, top-right of the cabinet.
 *
 * The language was decided entirely by the client card until now, so a client
 * whose card said Ukrainian had no way to read the page in English — and a
 * project sold in two currencies showed both at once with no way to collapse
 * them. backlog b3f87131 / ef0c7e7f.
 *
 * Plain segmented buttons rather than a dropdown: two or four options each,
 * and a client should not have to discover a menu to read their own portal.
 */
const PrefSwitcher = ({ lang, onLang, currency, onCurrency }) => (
  <div className="pref-switch" role="group">
    <div className="pref-group">
      {CABINET_LANGUAGES.map((l) => (
        <button
          key={l.code}
          type="button"
          className={l.code === lang ? "on" : ""}
          onClick={() => onLang(l.code)}
          aria-pressed={l.code === lang}
          title={l.label}
          data-testid={`cabinet-lang-${l.code}`}
        >
          {l.code.toUpperCase()}
        </button>
      ))}
    </div>
    <div className="pref-group">
      {CABINET_CURRENCIES.map((c) => (
        <button
          key={c.code}
          type="button"
          className={c.code === currency ? "on" : ""}
          onClick={() => onCurrency(c.code)}
          aria-pressed={c.code === currency}
          title={c.label}
          data-testid={`cabinet-ccy-${c.code}`}
        >
          {c.short}
        </button>
      ))}
    </div>
  </div>
);

export default PrefSwitcher;
